import { LocalizationModel } from '@shared/core';
import { IBaseValueModel } from './base.model';
import { VehicleTypeEnum } from './vehicle.model';

export const defaultTariffId = '5331e986-cac1-43a1-a10f-5f2af1032ae4';

export interface ITariffTier {
  label: string;
  hourFrom: number;
  hourTo: number;
  ratePerHour: number;
  sortOrder: number;
}

export interface ITariffItem {
  ratePerHour: number;
  minCharge: number;
  freeMinutes: number;
  dayMaxAmount: number;
  timeFrom: string;
  timeTo: string;
  daysOfWeek: number[];
  priority: number;
  isActive: boolean;
  tiers: ITariffTier[];
}

export interface ITariffResponseModel {
  parkingLotId: string;
  name: string;
  id?: string;
  tariffs: ITariffItem[];
}

export interface ITariffParams {
  pageIndex?: number;
  pageSize?: number;
  isActive?: boolean;
  parkingLotId?: string;
}

export interface ITariffModel {
  city: string;
  created_at: string;
  description: LocalizationModel;
  name: LocalizationModel;
  periods: ITariffPeriodWrapper;
  ruleGroups: ITariffRuleWrapper[];
  updated_at: string;
  uuid: IBaseValueModel;
  zones: ITariffZone[];
  lockedForChanges?: boolean;
}

export interface ITariffPeriodWrapper {
  day_offs?: ITariffPeriod[];
  dayOffs?: ITariffPeriod[];
  holidays?: ITariffPeriod[];
  weekdays?: ITariffPeriod[];
}

export interface ITariffPeriod {
  end: number;
  rule_group_index: number;
  start: number;
  ruleGroupIndex?: number;
}

export interface ITariffRuleWrapper {
  rules: ITariffRule[];
}

export interface ITariffRule {
  end: number;
  price: number;
  rule_group_index: number;
  start: number;
  vehicle_type?: ITariffVehicleType;
  vehicleType?: VehicleTypeEnum;
}

export interface ITariffZone {
  number: string;
  active: boolean;
}

export enum ITariffVehicleType {
  CAR = 1,
  TRUCK = 2,
  MOTORCYCLE = 3,
  BUS = 4,
}

export interface ITariffPeriodRulesPayload {
  period: ITariffPeriod;
  rules: ITariffRule[];
}

export enum IPeriodTypeEnum {
  WeekDays = 'weekdays',
  DayOffs = 'day_offs',
  Holidays = 'holidays',
}

export const ITariffRuleVehicleTypeLabel = {
  [ITariffVehicleType.CAR]: 'Легковые',
  [ITariffVehicleType.TRUCK]: 'Тягачи',
  [ITariffVehicleType.MOTORCYCLE]: 'Мотоцикл',
  [ITariffVehicleType.BUS]: 'Автобусы',
};

export const VehicleTypeToTariffVehicleTypeMapper: Record<VehicleTypeEnum, ITariffVehicleType> = {
  [VehicleTypeEnum.Car]: ITariffVehicleType.CAR,
  [VehicleTypeEnum.Truck]: ITariffVehicleType.TRUCK,
  [VehicleTypeEnum.Motorcycle]: ITariffVehicleType.MOTORCYCLE,
  [VehicleTypeEnum.Bus]: ITariffVehicleType.BUS,
};
